"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GA = void 0;
const react_ga4_1 = require("react-ga4");
const ga4Actions = {
    name: 'GA',
    init: ({ userId, gaCustomDimensions, tokens, isProduction }) => {
        if (!tokens['GA']) {
            console.warn('Cannot initialize GA. Google Tag ID is not defined.');
            return false;
        }
        if (!react_ga4_1.default.isInitialized) {
            try {
                const gaOptions = Object.assign(Object.assign({}, (!isProduction && { debug_mode: true })), { custom_map: gaCustomDimensions || {
                        dimension1: 'clinicId',
                    }, userId: userId });
                react_ga4_1.default.initialize(tokens['GA'], { gaOptions });
            }
            catch (error) {
                console.error(error);
                return false;
            }
        }
        return true;
    },
    identify: ({ userInfo }) => {
        if (!react_ga4_1.default.isInitialized) {
            console.warn('Cannot identify user in GA. GA is not initialized.');
            return false;
        }
        if (!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.id)) {
            console.warn('Cannot set user in GA. userInfo.id is not defined.');
            return false;
        }
        try {
            react_ga4_1.default.set({ userId: userInfo === null || userInfo === void 0 ? void 0 : userInfo.id });
        }
        catch (error) {
            console.error('GA set failed.');
            return false;
        }
        return true;
    },
    track: ({ isProduction, eventName, eventData }) => {
        if (!react_ga4_1.default.isInitialized) {
            console.warn('Cannot track event in GA. GA is not initialized.');
            return false;
        }
        if (!isProduction && eventName.length > 40) {
            console.error('Event name cannot be more than 40 chars', { eventName });
        }
        try {
            react_ga4_1.default.event(eventName, eventData);
        }
        catch (error) {
            console.error(error);
            return false;
        }
        return true;
    },
};
exports.GA = ga4Actions;
//# sourceMappingURL=index.js.map